/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Success': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<circle pid="0" cx="10" cy="10" r="10" fill="#9BC225"/><path pid="1" d="M14.08 7.995l-4.731 4.75a.855.855 0 01-.618.25.85.85 0 01-.607-.25l-2.37-2.37a.884.884 0 010-1.24.875.875 0 011.235 0l1.742 1.75 4.113-4.13a.875.875 0 011.235 0c.339.35.339.9 0 1.24" fill="#fff"/>'
  }
})
